<template>
  <Toast v-model="showToast" v-if="showToast" :msg="msg"></Toast>
</template>
<script>
import Toast from '@/components/Toast'
import { fetchOtherPrizeList, fetchMyPrize, submitMailAddress, fetchShowDrawPage, doStartDraw } from '@/services/prizedraw.js'
import { errorReport } from '@/utils/index.js'
import tujialogin from '@/utils/tujialogin.js'

export default {
  mixins: [tujialogin],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      // 展示接口报错信息
      showToast: false,
      // 报错信息
      msg: '',
      // 需要传的数据
      prizeInfo: {
        // 我的抽奖数据
        myPrize: [],
        // 开始抽奖的数据
        allPrize: {},
        // 别人的抽奖数据
        otherPrize: []
      }
    }
  },
  async created() {
    await this.initDrawPage()
  },
  watch: {
    async payLoad(newVal) {
      switch (newVal.type) {
      case 'drawprize':
        this.doStartDraw()
        break
      case 'setAddress':
        this.submitMailAddress(newVal.data)
        break
      case 'refreshPrize':
        await this.initDrawPage()
        break
      default:
      }
    }
  },
  methods: {
    /**
     * 抽奖页面配置
     */
    initDrawPage() {
      const { items } = this.compProps.mate || {}
      return fetchShowDrawPage(items.id).then(async(res) => {
        if (res && res.errcode === 0) {
          this.prizeInfo.allPrize = res.data || {}
          const { prizeList = [] } = res.data
          if (prizeList.length) {
            this.prizeInfo.prizeList = this.addDrawBtn(prizeList)
          }
          if (!this.canDrawPrize()) {
            // 活动未开始时不去请求获奖人员列表
            this.refreshOtherPrizeList(items.id)
          }
          const isLogin = await this.isLogin()
          if (isLogin) {
            this.refreshMyPrize()
          }
          this.$emit('init', {
            ...this.prizeInfo,
            id: items.id
          })
        } else {
          if (res.errmsg) {
            this.doShowToast(res.errmsg)
          }
        }
      })
    },
    /**
    * 他人获奖记录
    * @param {Srting} promotionCode 抽奖code
    */
    async refreshOtherPrizeList(promotionCode) {
      try {
        const otherPrizeList = await fetchOtherPrizeList(promotionCode)
        if (otherPrizeList && otherPrizeList.errcode === 0) {
          this.prizeInfo.otherPrize = otherPrizeList.data
          this.$emit('update', this.prizeInfo)
        }
      } catch (e) {
        console.log(e)
        errorReport(e)
      }
    },
    /**
    * 获取我的奖品
    * @param {Srting} promotionCode 抽奖code
    */
    async refreshMyPrize(promotionCode) {
      const { items } = this.compProps.mate || {}
      try {
        const myPrizeData = await fetchMyPrize(items.id)
        if (myPrizeData && myPrizeData.errcode === 0) {
          this.prizeInfo.myPrize = myPrizeData.data
          this.$emit('update', this.prizeInfo)
        }
      } catch (e) {
        console.log(e)
        errorReport(e)
      }
    },
    /**
     * 提交邮寄地址
     * @param {Object} mailData  邮寄信息数据
     */
    async submitMailAddress(mailData) {
      try {
        const mainAddressData = await submitMailAddress(mailData)
        if (mainAddressData && mainAddressData.errcode === 0) {
          this.refreshMyPrize()
          this.$emit('finish', { type: 'saveFinish', data: new Date().getTime() })
        } else {
          this.doShowToast(mainAddressData.errmsg)
        }
      } catch (e) {
        console.log(e)
        errorReport(e)
      }
    },
    /**
     * 开始抽奖
    */
    async doStartDraw() {
      const { items } = this.compProps.mate
      if (this.canDrawPrize()) {
        this.doShowToast('当前活动未激活，暂不可进行抽奖')
        this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
        return
      }

      try {
        const startDrawData = await doStartDraw(items.id)
        if (startDrawData && startDrawData.errcode === 0) {
          this.$emit('finish', { type: 'drawFinish', data: startDrawData.data })
        } else if (startDrawData && startDrawData.errcode === 55004) {
          this.goLoginPage()
        } else {
          this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
          this.doShowToast(startDrawData.errmsg)
        }
      } catch (e) {
        this.doShowToast('系统开小差了，一会再试试吧')
        this.$emit('finish', { type: 'cantDraw', data: new Date().getTime() })
        console.log(e)
        errorReport(e)
      }
    },
    /**
    * 按顺时针方向调整奖品顺序
    */
    dealAllPrizeList(allPrizeList) {
      let oldValue, newValue
      allPrizeList.forEach((prize, index) => {
        if (index === 3) {
          oldValue = prize
          allPrizeList[index] = allPrizeList[8]
        }
        if (index === 5) {
          newValue = prize
          allPrizeList[index] = oldValue
          allPrizeList[8] = newValue
        }
        if (index === 6) {
          newValue = prize
          allPrizeList[index] = allPrizeList[7]
          allPrizeList[7] = newValue
        }
      })
    },
    /**
     * 奖品列表中添加抽奖按钮项:按钮项的prizeType定义为-1
     */
    addDrawBtn(allPrizeList) {
      allPrizeList.splice(4, 0, { prizeType: -1 })
      this.dealAllPrizeList(allPrizeList)
      return allPrizeList
    },
    /**
     * 判断是否可抽奖
     */
    canDrawPrize() {
      const { startTime, endTime, serverTime } = this.prizeInfo.allPrize
      return (serverTime < startTime || serverTime > endTime)
    },
    /**
     * 展示接口报错信息
     * @param {String} msg 报错信息
     */
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    }
  },
  components: {
    Toast
  }
}
</script>
